let _Vue = null

export default function install(Vue) {
  if (Vue && _Vue === Vue) return

  _Vue = Vue

  Vue.mixin({
    beforeCreate: _init
  })
}

function _init() {
  if (this.$options.eventBus) {
    this.$eventBus = this.$options.eventBus
  } else {
    this.$eventBus = this.$parent && this.$parent.$eventBus
  }
}
